import { InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import React from 'react';

import * as S from './styles';
import type { InfoBoxType } from './styles';

export interface InfoBoxProps {
	message: string;
	type?: InfoBoxType;
}

export function InfoBox({ message, type = 'info' }: Readonly<InfoBoxProps>): JSX.Element {
	const isWarning = type === 'warning';

	return (
		<S.Container type={type}>
			<>
				{isWarning ? (
					<WarningOutlined style={{ fontSize: '1.25rem' }} />
				) : (
					<InfoCircleOutlined style={{ fontSize: '1.25rem' }} />
				)}{' '}
				{message}
			</>
		</S.Container>
	);
}
